export const NEAREST_CLUB_COUNT = 4;
